module.exports = __webpack_public_path__ + "img/P41-zh.45846275.png";